import { Action, Reducer } from "redux";
import { CartCountStatusState, CartCountStatusTypes, CartCountStatusActionTypes } from "./cartCountStatusTypes";

export const INITIAL_STATE: CartCountStatusState = {
	cartCountStatus: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
};

const cartCountStatusReducer: Reducer<CartCountStatusState> = (
	state: CartCountStatusState = INITIAL_STATE,
	action: Action,
) => {
	const actionTypes = action as CartCountStatusActionTypes;
	switch (actionTypes.type) {
		case CartCountStatusTypes.GET_CART_COUNT_STATUS:
			return {
				...state,
				cartCountStatus: { ...state.cartCountStatus, isLoading: true },
			};
		case CartCountStatusTypes.SAVE_CART_COUNT_STATUS:
			return {
				...state,
				cartCountStatus: {
					...state.cartCountStatus,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		case CartCountStatusTypes.RESET_REDUCER_CART_COUNT_STATUS:
			return {
				...state,
				cartCountStatus: INITIAL_STATE.cartCountStatus,
			};
		default:
			return state;
	}
};

export default cartCountStatusReducer;
